module.exports = __webpack_public_path__ + "static/media/tensor.7cc2bb63.png";